<template>
  <div style="width: 100%;">
    <b-row @scroll="onScroll" style="margin-right: 0px; margin-left: 0px;">
      <div ref="scroll-area" class="scroll-area" style="width: 100%" @scroll="onScroll">
        <b-row ref="scroll-content" align-h="center" class="title-row" :no-gutters="true" >
          <b-col style="padding-right: 3px;" cols="12" v-if="this.releaseDates.length > 0">
            <div v-for="(releaseDate, index) in this.sortedReleaseDates" :key="index">
              <GameCard :releaseDate="releaseDate"/>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-row>
  </div>
</template>

<script>
import GameCard from './GameCard'
import moment from 'moment'

export default {
  name: 'feed',
  components: {
    GameCard
  },
  metaInfo () {
    return {
      titleTemplate: 'Mobile video game release calendar | WhenIsGameReleased.com',
      htmlAttrs: {
        lang: 'en'
      },
      meta: [{
        vmid: 'description',
        name: 'description',
        content: 'Mobile video game release feed'
      }]
    }
  },
  data () {
    return {
      dayOffset: 0,
      fetchRangeInDays: 7,
      loadBalancer: false,
      height: 0
    }
  },
  computed: {
    sortedReleaseDates () {
      let toBeSorted = this.releaseDates.slice()
      return toBeSorted.sort((a, b) => new Date(a.date) - new Date(b.date))
    },
    releaseDates () {
      return this.$store.state.feedDates || []
    },
    startDate () {
      return moment().utc().add(this.dayOffset, 'days').startOf('day').format()
    },
    endDate () {
      return moment().utc().add(this.dayOffset, 'days').endOf('day').format()
    },
    fetchedStartDate () {
      let earliest = null

      if (this.releaseDates.length === 0) return moment().format()

      for (let date of this.releaseDates) {
        if (earliest === null || new Date(earliest.date) > new Date(date.date)) earliest = date
      }

      return earliest.date
    },
    fetchedEndDate () {
      let latest = null

      if (this.releaseDates.length === 0) return moment().format()

      for (let date of this.releaseDates) {
        if (latest === null || new Date(latest.date) < new Date(date.date)) latest = date
      }

      return latest.date
    }
  },
  methods: {
    loadMoreFuturePosts (startDate) {
      if (!this.loadBalancer) {
        this.$store.dispatch('concatReleaseDatesByStart', { startDate })
        this.loadBalancer = true
        setTimeout(() => { this.loadBalancer = false }, 100)
      }
    },
    async loadMoreHistoryPosts (endDate) {
      if (!this.loadBalancer) {
        this.loadBalancer = true
        setTimeout(() => { this.loadBalancer = false }, 100)
        await this.$store.dispatch('concatReleaseDatesByEnd', { endDate })
        this.$refs['scroll-area'].scrollTop = this.$refs['scroll-content'].clientHeight - this.height
        this.height = this.$refs['scroll-content'].clientHeight
      }
    },
    init (startDate) {
      if (!this.loadBalancer) {
        this.$store.dispatch('firstFeedLoad', { startDate })
        this.loadBalancer = true
        setTimeout(() => { this.loadBalancer = false }, 100)
      }
    },
    async onScroll ({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (scrollTop + clientHeight >= scrollHeight) {
        this.loadMoreFuturePosts(this.fetchedEndDate)
      }
      if (scrollTop === 0) {
        this.loadMoreHistoryPosts(this.fetchedStartDate)
      }

      this.height = this.$refs['scroll-content'].clientHeight
    }
  },
  mounted () {
    // We have to add -1 days to get todays games as well.
    // TODO: fix that
    this.init(moment().add(-1, 'days').format('YYYY-MM-DD'))
  },
  updated () {
    if (this.height === 0) this.$refs['scroll-area'].scrollTop = 1
  }
}
</script>
<style>
@media (max-width: 768px) {
  .scroll-area {
    height: 73vh;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
  }
}
</style>
